export {default} from './main-slide';
